export default {
  general: {
    login: 'Login',
    password: 'Password',
    email: 'Email',
    firstName: 'First name',
    lastName: 'Last name',
    name: 'Name',
    address: 'Address',
    zip: 'ZIP',
    city: 'City',
    phone: 'Phone number',
    birthdate: 'Birthdate',
    ok: 'Okay',
    cancel: 'Cancel',
    save: 'Save',
    swisspass: 'SwissPass',
    skicard: 'KeyCard',
    printAtHome: 'Print@Home',
    user: 'User',
    delete: 'Delete',
    next: 'Next',
    back: 'Back',
    select: 'Select',
    skiticket: 'Ski pass',
    overview: 'Overview',
    I: 'Me',
    date: 'Date',
    here: 'here',
    options: 'Options',
    option: 'Option',
    loadMore: 'Show more',
    ticket: 'Ticket',
    category: 'Category',
    from: 'from',
    rowsPerPage: 'Rows per page',
    to: 'to',
    loadingData: 'Loading data',
    close: 'Close',
    price: 'Price',
    country: 'Country',
    today: 'Today',
    days: 'Days',
    day: 'Day',
    print: 'Print',
    apply: 'Apply',
    toCart: 'To Basket'
  },
  layout: {
    register: 'Register',
    booking: 'Online ticket',
    selectLanguage: 'Language',
    selectLanguageModalHeader: 'Select Language',
    userAccount: 'Profile',
    logout: 'Logout',
    menu: 'Menu',
    apply: 'Log-in',
    helpAndFaq: 'Help and FAQ',
    contact: 'Contact',
    customerManagement: 'Cash desk',
    dashboard: 'Admin-Area',
    agb: 'Terms & Conditions',
    myCards: 'My Cards'
  },
  registration: {
    firstName: 'First name *',
    lastName: 'Last name *',
    email: 'Email *',
    password: 'Password *',
    passwordRepete: 'Repeat password *',
    acceptAgb: 'I accept the Terms & Conditions and agree with the Data Privacy Terms *',
    acceptDataPrivacy: 'I agree with the Data Privacy Terms *',
    youHaveToAcceptAgb: 'Please accept the Terms & Conditions and the Data Privacy Terms',
    youHaveToAcceptDataPrivacy: 'Please accept the Data Privacy Terms',
    registrationTitle: 'Create user account',
    register: 'Register',
    eMailRequired: 'Please fill in the e-mail address',
    isNotEmail: 'This is not a valid e-mail address ',
    passwordWrong: 'The requirements are not met',
    passwordRequired: 'Please fill in your password',
    passwordConstraints: 'Requirements Password',
    passwordIsNotUid: 'The password shall not contain e-mail, first name or last name',
    passwordHasLetters: 'The password must contain capital letters and lower case',
    passwordHasCapitalLetter: 'The password must contain at least one capital letter',
    passwordHasSpecialCharacter: 'The password must contain at least one special character',
    passwordHasNumber: 'The password must contain at least one number',
    passwordEqual: 'The passwords must be identical',
    passwordLength: 'The password must be at least 8 characters long',
    alreadyAccount: 'You already have an account? Click here.',
    firstNameRequired: 'Please fill in the first name',
    lastNameRequired: 'Please fill in the last name',
    checkInput: 'Check',
    street: 'Address',
    streetStar: 'Address *',
    zip: 'ZIP *',
    city: 'City',
    cityStar: 'City *',
    cityRequired: 'Please fill in the city',
    country: 'Country',
    zipRequired: 'Please fill in the ZIP-code',
    addressRequired: 'Please fill in the address',
    phone: 'Phone',
    phoneStar: 'Phone *',
    phoneRequired: 'Please fill in the phone number.',
    companyRequired: 'Please fill in the company',
    companyStar: 'Company *',
    company: 'Company'
  },
  login: {
    loginHeadline: 'Login',
    checkMail: 'Check e-mail',
    passwordRequired: 'You need to fill in a password',
    saveCookie: 'Keep me logged-in',
    onlyOnPersonalComputer: 'Only recommended on your personal computer',
    forgetPw: 'Forgot password?',
    passwordSentExplanation: 'We have just sent you an e-mail with a new password. Check your mailbox and log in with your new password.',
    passwordSentInfo: 'Wondering why we are sending you a new password? One of our employees has ' + 'In the past, we have accepted a reservation/booking on your behalf and created an account in the process. ' + 'In this way, we would like to offer you the greatest possible convenience and speed up your registration. With the password we have just sent you, ' + 'you can now log in to your account.',
    acceptAgbsButton: 'Accept Terms & Conditions',
    acceptAgbs: 'Please accept the Terms & Conditions',
    errorWhileDataTransfer: 'An error has occurred while transferring your data. Please try again.'
  },
  spinner: {
    pleaseWait: 'One moment please',
    tryToLogin: 'We try to log you in automatically.'
  },
  notify: {
    errorDeleteCapacity: 'The capacity could not be deleted.',
    errorUpdateCapacity: 'The change could not be made.',
    userSuccessfullyRegistered: 'Thank you for your registration. ',
    registrationFailed: 'Sorry, something went wrong. Please try again.',
    standardError: 'Sorry, a mistake occurred. Please try again later.',
    passwordWasSent: 'You received an e-mail with your password.',
    emailDoesNotExist: 'The e-mail doesn’t exist. You need to register first.',
    loginSuccess: 'Successfully logged-in!',
    loginError: 'A mistake occurred while logging-in.',
    logoutSuccess: 'Successfully logged-out!',
    autologinFailed: 'Unfortunately, we couldn’t log you in automatically ',
    languageChangedSuccessfully: 'We saved the new language selection in your profile.',
    languageCouldNotBeSaved: 'Unfortunately, we couldn’t save the new language selection in your profile.',
    profileInfoSaved: 'We saved the information. Thank you!',
    mailNotSaved: 'Unfortunately, we couldn’t save the e-mail address.',
    mailsHaveToBeEquals: 'The e-mails are not the same.',
    passwordChangedSuccessfully: 'The password has been changed successfully.',
    pwResetCodeSentToMail: 'We have sent you an e-mail with a code. Copy the code in the field below.',
    wrongCodeSent: 'You have entered a wrong code. Please check it again.',
    passwordResetSuccessfull: 'You have reset the password successfully.',
    clickedDayHasToBeLinked: 'You can only select days in a row.',
    maxReservationTimeLimitReached: 'You cannot book more days in a row',
    dayIsInPast: 'The date is outside the season',
    selectDay: 'Please select a date and a ticket',
    fullFillForm: 'Please fill in all required fields',
    voucherIsInvalid: 'Voucher is not valid:',
    maxDayLimitExeeded: 'You can only book {maxSelectedDays} days in a row.',
    loadingWeatherFailed: 'Weather forecast data could not be loaded',
    updatingWeatherFailed: 'Forecast could not be adjusted',
    errorWhileFetchingCapacities: 'The capacities could not been loaded.',
    errorCreatingNewCapacity: 'The capacity was not created.'
  },
  profile: {
    personalInformation: 'Personal information',
    birthday: 'Birthday *',
    changeMailModalHeader: 'Change e-mail address',
    newMailFirst: 'New e-mail address *',
    newMailRepeat: 'Repeat new e-mail address *',
    perfectSkiDay: 'Describe your perfect skiing day',
    optionalDataHeaderText: 'Additional information',
    favoriteSkiRessort: 'My favorite ski resort',
    favoriteSkiMask: 'My favorite ski brand',
    education: 'Education',
    profession: 'Profession',
    changePassword: 'Change password',
    changePasswordModalTitle: 'Change password',
    myCards: 'My cards',
    cardType: 'card type',
    cardNumber: 'number',
    deactivateProfile: 'Deactivate profile',
    reallyDeactivateProfile: 'Do you really want to deactivate your profile?',
    reallyDeleteText: 'If you deactivate your profile, we will delete your stored mail address. ' + '<b>You will no longer be able to use the account. Your account will be deactivated!</b>',
    yourName: 'Your name',
    doesNotMatchWithYourName: 'The entry does not correspond to your name',
    enterYourNameForSecurityReasons: 'Please fill in your first name'
  },
  rule: {
    inputRequired: 'Input required',
    firstName: 'Please fill in your first name',
    lastName: 'Please fill in your last name',
    birthdate: 'Please fill in your birthdate',
    selectCard: 'Please select storage location',
    selectUser: 'Assign Person',
    selectDataMedium: 'Please select a storage location',
    addVoucher: 'Please enter a valid voucher code'
  },
  resetPw: {
    resetPwButton: 'Reset password',
    explanation: 'Enter the e-mail address with which your account is connected. We will send you a code to reset your password.',
    headline: 'Reset password',
    codeRequired: 'We have sent you an e-mail with a code. Copy the code in the field below.',
    resetCode: 'Enter the code, which you have received per e-mail, here.',
    newPw: 'New password *',
    newPwRepeat: 'Repeat new password *',
    userNotFound: 'This mail is not registered'
  },
  myProfiles: {
    newProfile: 'Add user',
    birthday: 'Birthday *',
    birthdayRequried: 'Please select the birthdate.',
    profilesNotLoaded: 'The user profiles could not be updated',
    userDeleted: 'We have deleted the user profile',
    userNotDeleted: 'Unfortunately, we could not delete the user.',
    reallyDelete: 'Do you really want to delete this user?'
  },
  cardAdder: {
    addCard: '+',
    cardNumber: 'Card number',
    cardNumberRequired: 'Please fill in the card number',
    waitingForCamera: 'We\'re loading the camera. One moment, please. Please check your browser settings if ' + 'the camera cannot be charged within a few seconds.',
    zipRequired: 'Please enter your ZIP-code.',
    cardDescription: 'Name your card',
    acceptSwisspassAgb: 'Please accept the Terms & Conditions of SwissPass.',
    swisspassAgb: 'I accept the SwissPass Terms & Conditions',
    smartCard: 'Axess KeyCard',
    captureSmartCard: 'Capture Axess KeyCard',
    smartCardInputExplanation: 'Basically you can use any KeyCard from Axess ' + '(also from another ski resort). To do this, enter in the field "Card number" the number ' + 'from the back of your KeyCard. The input is <u>with hyphen.</u>'
  },
  addNewProfile: {
    newProfileAddedSuccessfully: 'Add new profile',
    birthdayRequired: 'Please enter the birthdate.',
    newCardModalTitle: 'Add card',
    cardAdded: 'Card has been added',
    invalidSkicardNumber: 'The card number is wrong.',
    invalidSwisspassNumber: 'The card number is incorrect. Enter your 11-digit card number in the "Card number" field. ' + 'SwissPass number including S but without hyphens. You will find the number on the back ' + 'hyphens in the “Card number” field. You can find the number on the back of your SwissPass.',
    cards: 'Cards',
    cardDelted: 'We have deleted the card',
    userUpdated: 'We have updated the user',
    mailAlreadyExists: 'This e-mail already exists. Please use another e-mail address.',
    wrongBirthdayFormat: 'Format DD.MM.YYYY required.',
    userLinkedToRegion: 'The person was added. Please add the customer now via the search field.'
  },
  booking: {
    selectDate: 'Select date',
    selectPerson: 'Select persons',
    timeLeft: 'Remaining booking time',
    cashPaymentFailed: 'Payment could not be saved!',
    cashPaymentSuccessful: 'Payment successful',
    noteCouldNotBeSaved: 'Comment could not be saved.',
    noteSaved: 'Comment was saved.',
    unexpectedAmount: 'ATTENTION: The amount collected does not match the amount of the price calculation! ' + 'Please inform Pricenow support immediately with the following information: Booking ID: {bookingId} / Expected amount: {expectedAmount}',
    bookingChanged: 'Changes to the booking are saved.',
    bookingNotChanged: 'Changes could not be saved.'
  },
  dashboard: {
    pricing: 'Pricing',
    datanalytics: 'data analytics',
    customerManagement: 'Customer management'
  },
  noAccess: {
    noAccess: 'You do not have access to this section',
    goToLogin: 'To Log-in'
  },
  selectDate: {
    fromPrice: 'from',
    selectDayInCalendar: 'Select a date in the calendar',
    addTicketHint: 'Add a ticket',
    totalWithDiscount: 'Total',
    pricesFor: 'Prices shown for',
    who: 'Add number of people',
    infoHeader: 'Select the dates',
    infoText: 'Select the dates of your skiing day. You can select from 1 to 14 days. To do so, click on the list below.'
  },
  bookingOptions: {
    reclassification: 'Rebooking',
    basic: 'Basic',
    flex: 'Flex',
    selectTarif: 'Select the desired fare',
    basicTarif: 'Basic Fare',
    flexTarif: 'Flex Fare',
    chooseYourExtras: 'Add your Extras',
    dateSelected: 'Dates selected',
    optionOnlyForFullDayAvailable: 'Option only available for one-day ski passes',
    addOption: 'Add Extra'
  },
  personalData: {
    newCustomer: 'I am a new customer',
    registerNow: 'Sign up now',
    alreadyCustomer: 'I am already a customer',
    furtherWithoutRegistration: 'Continue without registration',
    whereToStoreTheTicket: 'Choose the storage location',
    saveTicketHere: 'My ticket should be stored here',
    whereToDeliver: 'To where shall we deliver the tickets?',
    toWhomBelongsTicket: 'To whom does this ticket belong to?',
    addNewPerson: 'New person',
    addNewCard: 'New card',
    cardBuyMsg: 'The KeyCard is purchased. It can be recharged as often as desired.',
    selectCard: 'Choose a card',
    newSwisspass: 'add new SwissPass',
    newKeyCard: 'No KeyCard. Add one.',
    tooYoung: 'Person is too young for this ticket',
    tooOld: 'Person is too old for this ticket',
    personAlreadyInUse: 'Person has already been selected for another ticket',
    advantage1: 'Special offers for members',
    advantage2: 'Book your skiing day easily',
    advantage3: 'Book quickly for Family & Friends'
  },
  bookingOverview: {
    dayDiscounts: 'Multi-day discount',
    flexTarif: 'Flex Fare',
    subtotal: 'Subtotal',
    addNewPerson: 'Add additional person',
    vouchers: 'Voucher',
    familyDiscount: 'Family discount',
    areYouFamily: 'Are you a family?',
    commingAsFamily: 'Confirm',
    familyDiscountAdvantages: 'As a family you can benefit from attractive discounts. Please confirm, ' + 'that the selected children\'s tickets are for children in your family.',
    spotChecksPossible: 'It is possible to carry out samples.',
    bookingOverview: 'Booking summary'
  },
  success: {
    authtokenProblem: 'Probably, you have disabled cookies. Please, login and release the booking in your profile.',
    missingLiability: 'There is a problem. Obvious, your bank is not trustworthy.',
    checkForPaymentStatus: 'We check, whether the payment was successful.',
    paymentErrorTryAgain: 'Click here to trigger the payment again',
    paymentSuccessfull: 'Welcome on the slopes!',
    paymentSuccessfullSubheading: 'We are looking forward to seeing you soon.',
    paymentSuccessfullSubheadingChaeserrugg: 'We wish you a relaxing time in the Chäserrugg area.',
    unknowError: 'An error has occurred',
    goToBookingOverview: 'Go to booking overview',
    retryPayment: 'Try again',
    bookingTooOld: 'Booking has expired',
    goBack: 'New booking'
  },
  purchase: {
    voucherInput: 'Enter voucher code',
    voucherNotValidated: 'This voucher has not been added yet.',
    cashVoucher: 'Redeem voucher',
    bookNow: 'Book now',
    validateVoucher: 'Check voucher',
    voucherAlreadyAdded: 'Voucher has already been added',
    pricesTooOld: 'Time has expired.',
    notAllowed: 'You are not allowed to book tickets for the selected users.',
    invalidTicketMode: 'Invalid ticket mode. Please contact the support.',
    selectedKeycardWrong: 'The selected ski pass does not belong to the selected user',
    tryingToBookInThePast: 'You are trying to book a ticket for past dates.',
    ticketCategoryInvalid: 'The ticket category is invalid. Please contact the support.',
    invalidTicketType: 'Invalid ticket type. Please contact the support.',
    wrongOrderOfTickets: 'Internal error: Wrong order of tickets. Please contact the support.',
    wrongTimeZone: 'You are not able to book tickets for this time zone. Please contact the support.',
    invalidOption: 'Invalid option selected. Please contact the support.',
    amountFailed: 'An error has occurred during the calculation. Please contact the support.',
    flexBasicCombination: 'An error has occurred when selecting the Flex/Basic Option. Please contact the support.',
    newShadowUserNotCreated: 'It was not possible to add the user. Please contact the support.',
    newSkiCardNotCreated: 'It was not possible to add the card to the new user. Please contact the support.',
    goToMyBookings: 'Go to booking overview',
    buyMore: 'Buy more tickets',
    acceptAgs: 'Please read and accept the Data Privacy Terms and the Terms & Conditions to complete the booking.',
    IAcceptAgb: 'I have read and accept the Data Privacy Terms and the Terms & Conditions.',
    accept: 'Accept',
    addMissingUserDataModalHeader: 'Almost completed!',
    vaucherInput: 'Redeem voucher',
    decline: 'Reject',
    book: 'Book',
    voucherInfoText: 'If you have received an online credit code, you can enter it here. You can ' + 'also find all your online credit codes in your profile (<span class="fa fa-user"></span>).'
  },
  outOfTime: {
    runOutOfTime: 'Time has expired.',
    reloadData: 'Please restart the booking process'
  },
  dataTable: {
    noDataAvailable: 'No dates available',
    noResultFound: 'No results found',
    allRows: 'All'
  },
  dataFooter: {
    pageText: '{0}-{1} of {2}',
    itemsPerPageText: 'Items per page:',
    itemsPerPageAll: 'All',
    itemsPerPageAllText: 'All',
    nextPage: 'Next page',
    prevPage: 'Previous page',
    firstPage: 'First page',
    lastPage: 'Last page'
  },
  myBookings: {
    myBookings: 'My bookings',
    newBookings: 'New booking',
    oldBookingsHeader: 'Past bookings',
    reference: 'Booking number',
    persons: 'Persons',
    destination: 'Ski resort',
    cancelBooking: 'Cancel',
    cancelBookingModalTitle: 'Sad, that you are not able to go skiing!',
    cancelBookingInformationA: 'Please click here to cancel your booking and to transfer your balance into a voucher. More information is available.',
    cancelBookingInformationB: 'Which tickets should be canceled and transferred into a voucher?',
    cancelButton: 'Cancel',
    areYouSure: 'Are you sure?',
    confirm: 'Confirm',
    overviewTicketsToCancelText: 'The following ticket will be canceled and transferred into a voucher',
    ticketsSuccessfullyCanceled: 'The tickets have been canceled and transferred into a voucher.',
    ticketsNotCanceled: 'Due to a technical error the tickets could not have been canceled.',
    isFlex: 'Non-cancellable',
    isStorno: 'Canceled',
    details: 'Booking details',
    noBookingFound: 'The booking has either expired or does not exist',
    ticketNr: 'Ticket number',
    noOptions: 'No',
    dataMedium: 'Memory device',
    pdfIsGenerating: 'PDF will be generated. Click here to try again.',
    downloadTicket: 'Download ticket',
    ticketNotPaid: 'Ticket has not been paid yet.',
    paymentDetails: 'Payment details entire booking',
    services: 'Services'
  },
  myVauchers: {
    myVauchers: 'My vouchersInstance',
    vaucherCode: 'Voucher code',
    credit: 'Balance',
    maxDate: 'Valid until',
    description: 'You can use your online credit to buy new offers in the webshop.',
    cashVaucher: 'Redeem',
    noDataAvailable: 'No online credit available'
  },
  cardsList: {
    addCard: 'SwissPass / KeyCard',
    noCardsAvailable: 'No cards available',
    unknownCardType: 'Unknown card type',
    description: 'Description'
  },
  overviewTicketOffice: {
    searchTicketCode: 'Validate ticket code',
    addSwisspass: 'Add SwissPass',
    addKeyCard: 'Add KeyCard',
    checkMail: 'We check the e-mail',
    keyCardAdded: 'KeyCard has been added.'
  },
  ticketOffice: { addSwisspass: 'Add SwissPass' },
  optionTable: { checkingAvailability: 'We check availability.' },
  bookingManagement: {
    loadingCamera: 'Camera loading...',
    validate: 'Validate',
    storno: 'Revoke Ticket',
    serachByName: 'Search by name',
    scanTicketCode: 'Scan ticket',
    ticketInvalidated: 'The ticket has been validated successfully',
    ticketNotInvalidated: 'The ticket could not be validated',
    user: 'User information',
    pricePaid: 'Price paid',
    days: 'Days booked',
    validatedBy: 'Validated by',
    ticketStornoSuccessfull: 'The ticket has been successfully transferred into a voucher',
    reallyStorno: 'Do you really want to cancel?',
    ticketStornoExplanaition: 'The ticket will be transferred into a voucher.',
    ticketAlreadyValidated: 'The ticket has already been validated!',
    ticketAlreadyCancelled: 'The ticket has already been cancelled and is invalid!',
    cancelledBy: 'Cancelled by',
    cancelledAt: 'Cancelled at',
    ticketNotPaid: 'The ticket has not been paid and is invalid!',
    selectTicket: 'Select ticket',
    ticketFromTo: 'Validity',
    ticketCode: 'Ticket code',
    ticket: 'Ticket',
    stornoNotPossible: 'Non-cancellable! Only on goodwill.',
    flexCanBeCancelled: 'Flex: Possible to cancel',
    stornoConditions: 'Conditions',
    minChar: 'Please enter at least three letters to start searching',
    falseAccessRights: 'You do not have the needed access rights. Please contact the support.',
    putTicketsOnKeyCard: 'Store ticket on ski card',
    resetKeyCardUid: 'reset',
    withoutDepot: 'Without deposit',
    withDepot: 'With deposit',
    ticketToCardAddedSuccessfully: 'Ticket add successfully to ski card',
    ticketAlreadyOnCard: 'Ticket has already been stored on a ski card!',
    skiCardNumberNotValid: 'The number of the ski card is invalid',
    noTicketsProvided: 'Technical error: No tickets which can be read.',
    ticketOverview: 'Ticket overview',
    ticketDoesNotExistInDatabase: 'The ticket does not exist in this database',
    skidata: 'Skidata',
    putOnKeycard: 'Ticket on KeyCard',
    externalTicketProvider: 'Status external ticketing system'
  },
  overviewPricing: {
    visitors: 'Visitors',
    visitorsForecast: 'Visitor forecast',
    pricesForecast: 'Price forecast',
    discountsOverview: 'Discount overview',
    actualPrice: 'Actual price',
    discountSum: 'Discounts',
    earlyDiscount: 'Early booking discount',
    phaseDiscount: 'Seasonality',
    weekdayDiscount: 'Weekday',
    weatherDiscount: 'Weather',
    overrideModalHeader: 'Override Model',
    currentPrice: 'Current price',
    inputRequired: 'You have to enter a price.',
    maxPrice: 'Maximum price',
    changingReason: 'Justify the price adjustment',
    newParamsStored: 'New inputs saved',
    guests: 'Guests',
    ticketPrice: 'Ticket price (CHF)',
    // not in use
    differentDiscounts: 'Discounts (%)',
    noMoreFuture: 'The display is not possible',
    reallySaveChanges: 'Are you sure you want to save the changes?',
    weatherCanNotBeChanged: 'The date is too fare in the future and cannot be changed manually.',
    commentRequired: 'Please justify the price adjustment.',
    product: 'Product',
    price: 'Price',
    bookings: 'Bookings',
    noChartData: 'No Data available',
    weekRange: 'Period',
    startDate: 'Start date',
    regions: 'Regions',
    week: 'Week',
    weeks: 'Weeks',
    quantity: 'Quantity',
    countSelectedDefinitions: '{counter} Selected Products',
    cannotShowAllEntriesInTables: 'Not all selected product definitions can be displayed in the graphic.',
    postedPrices: 'Prices',
    targetPrices: 'target prices',
    overwrite: 'Price override',
    history: 'Price history',
    undefined: 'Undefined'
  },
  captureUsers: {
    insertMail: '1. Insert e-mail of client',
    captureSwisspass: '2. Add SwissPass',
    createNewUser: '3. Complete information',
    unknownResponseStatus: 'Unknown response code',
    userAlreadyExists: 'User already exists',
    userAlreadyExistsExplanation: 'All good! The person already exists in our database. You can close the window.',
    checkSwisspass: 'Check SwissPass',
    swisspassCombinationWrong: 'SwissPass Number and ZIP do not match or are wrong.',
    shwadowUserAlreadyExists: 'The person is already registered in our system, but has never logged in. ' + 'Therefore, we have sent her an email with the necessary information. You can close the window.',
    mailSent: 'E-Mail sent'
  },
  registrationForm: {
    userAlreadyExists: 'User with this e-mail address already exists.',
    phoneNumberForQueries: 'Phone number for queries.',
    salutation: 'Salutation',
    salutationStar: 'Salutation *',
    selectSalutation: 'Please select the salutation',
    followingDestination: 'You have already registered in one of the following destinations',
    useYourPassword: 'Login with your password. If you have forgotten the password, you can reset it.'
  },
  SCountry: {
    country: 'Country',
    countryMandatory: 'Country *',
    countryIsMandatory: 'Choose your country'
  },
  missingUserData: {},
  bookingDetail: {
    showDetails: 'Show details',
    hideDetails: 'Hide details',
    noOptions: 'No',
    cancellationNumbers: 'Cancellation numbers',
    unpaidBookingCannotHaveAnAmount: 'An unexpected error has occurred: Unpaid booking cannot be cancelled with an amount greater than 0.',
    unpaidBookingToReleaseCapacities: 'This booking is unpaid. With the cancellation, possible capacity restrictions are released.',
    voucherAmount: 'Create online credit',
    voucherFor: 'Online credit for',
    stornoForZero: 'Bookings made in the name of an employee of the destination must be cancelled with 0 francs!',
    noVoucherWillBeCreated: 'No online credit will be created.',
    editBookingEntries: 'Edit services',
    closeEditBookingEntries: 'Cancel edit',
    editBuyer: 'Edity Buyer',
    validGA: 'Valid GA',
    invalidGA: 'No valid GA',
    validHTA: 'Valid Half-Fare Card',
    invalidHTA: 'No valid Half-Fare Card'
  },
  loginForm: {
    noAccount: 'No account yet? Register now',
    loginNow: 'Login',
    transferDataRequest: 'May we use your details?',
    tranferDataText: 'Your details are already stored with us. May we take over these details for the destination {destination}?',
    transferDataTextII: 'With your agreement you accept at the same time the terms and conditions of the destination {destination}. ' + 'You will find the current terms and conditions linked at the bottom of this web page.',
    accept: 'Accept',
    decline: 'Reject',
    authenticationFailed: 'The password or email is incorrect. Please check your input and try again.'
  },
  paymentHandler: { goToBooking: 'Back to home page' },
  bookingTarifs: {
    fare: 'Fare',
    basicDescription: 'With the <span class="font-weight-bold">Baisc fare</span> you purchase a ski ticket that cannot be rebooked or cancelled. ' + 'The ski ticket is only valid for the selected date. <br><br>' + 'With the <span class="font-weight-bold">Flex-Tarif</span> you purchase a ski ticket, which can be rebooked flexibly. You can use the ticket until ' + 'cancel at <span class="font-weight-bold">23:59</span> the previous day. In case of cancellation, the entire booking will be cancelled. ' + 'A cancellation of individual ski days ' + 'of a multi-day ticket is not possible. In this case, the original booking amount will be credited to you in the form of an online credit, ' + 'which you will find at your next ' + 'Online booking can redeem. <br><br>' + 'The <span class="font-weight-bold">Flex-Ticket</span> can be rebooked flexibly. Within the section “My bookings”, you can rebook your ticket until <span class="font-weight-bold">23:59</span> of the day before your (first) skiing day. In the case of a cancellation, the entire booking is cancelled. Cancellation of individual ski days of a multi-day ticket is not possible. You will receive the initial booking amount in the form of an online voucher. You can use this voucher for your next online booking. <br><br>' + 'With the <span class="font-weight-bold">optional tariff</span> (e.g. 3 Out of 4) you buy a ticket which gives you the flexibility to skip one day in your chosen period, e.g. in case of bad weather. Example: with a "3 out of 4" you can ski for 3 days in the period of 4 days starting from your chosen start date.',
    moreInformation: 'You can find more information here.'
  },
  bookingLogin: { futureAdvantages: 'Enjoy great advantages' },
  v2: {
    OptionsCouldNotBeenLoaded: 'The options could not be loaded',
    soldOut: 'sold out',
    availableOptions: 'only {availableOptions} pcs.'
  },
  v3: {
    pleaseConfirmMail: 'Please confirm your email address',
    confirm: 'Confirm',
    mailSuccessfullyConfirmed: 'Thank you very much! Your email address has been successfully confirmed.',
    goToLogin: 'To the login',
    pleaseSetPw: 'Almost there! Set another password.',
    usedTicketCannotBeCancelled: 'Tickets valid as of today must be additionally canceled in the ticket system!'
  },
  v4: {
    amount: 'Amount',
    unknownError: 'An unknown error has occurred (483). Please contact the support.',
    apiWasNotAbleToCalculateThePrice: 'There was an error calculating the price. Please contact the support.',
    triesToBookATicketForWrongAge: 'You are trying to book a ticket on a data carrier (e.g. Swisspass) that does not meet the age requirements.',
    ticketOrOptionCostsLessThanZero: 'You are trying to buy a ticket or option that costs less than or equal to 0 francs. Please contact the support.',
    skiCardAlreadyInUse: 'The card is already in use. Please choose another one.',
    stornoAmount: 'Amount',
    stornoReasonRequired: 'Please state reason for cancellation.',
    giveMeAStornoReason: 'Reason for cancellation',
    stornoAmountRequired: 'Please enter the amount to be cancelled.',
    stornoHistory: 'Cancellation history',
    selfStorno: 'user self',
    cashDeskStorno: 'Cashiers/administrators',
    selectCancellationType: 'Cancellation by',
    selectCancellationTypeRequired: 'Please select a cancellation type',
    cancellationDate: 'Cancelled on',
    noVoucherHasBeenGenerated: 'No online credit',
    voucherOriginalRatio: 'Online credit value / paid ticket price',
    filter: 'Filter',
    noNameFound: 'No name found',
    ticketUser: 'Ticket holder',
    alreadyUsed: 'Redeemed',
    cancellationDetailModalHeader: 'Cancellation details',
    cancellation: 'Cancellation',
    voucherValue: 'Online credit value',
    paidOriginalTicketPrice: 'Original price paid',
    ticketOwner: 'Tickets',
    voucherOwner: 'Online credit owners',
    voucherOwnerInfo: 'The online credit owner may differ from the ticket owner, because the buyer of a ticket is not necessarily the ticket owner.',
    noVoucherGeneratedInfo: 'No online credit was created. It is possible that the ticket was generated with a value of CHF 0.',
    // ohne Wert
    tooLateForCancellation: 'The ticket can no longer be cancelled. Cancellation is only possible until 23:59 on the day before the first ski day.'
  },
  v5: {
    seeYouInAutomn: 'We will be there for you again in autumn',
    goodPricesSoon: 'Then you can book your ski tickets at preferential prices right here again.',
    sommerTickets: 'Tickets for the summer time can currently be purchased directly at the cash desk.',
    goodSommerInTheMeanTime: 'We look forward to your visit and wish you sunny summer days in Bellwald in the meantime.',
    startdate: 'Select start date',
    searchPlaceholder: 'Search',
    selectDate: 'Please select a date',
    selectDuration: 'Please select the number of days',
    durationDropdown: 'Number of days',
    basketInProgress: 'You have to configure all products in your shopping cart before you can add new ones.',
    basketUpdateNotSuccessfull: 'The shopping cart could not be updated.',
    twoPossibilities: 'You have two options for entering the Swisspass number',
    scanQrCode: 'Hold the QR code (1) of your SwissPass in front of your mobile phone\'s/PC\'s camera.',
    cameraCapturing: 'Camera recording',
    manualCapturing: 'Manual entry',
    captureSwisspassNumber: 'In the "Card number" field, enter your 11-digit SwissPass number including S but without hyphens. ' + 'You will find the number on the back of your SwissPass (2).',
    keyCardCatpuring: 'Capture Keycard number',
    keyCardInputExplanation: 'In principle, you can use any SKIDATA keycard (also from other ski areas). ' + 'To do this, enter the 23-digit number from the front of your keycard in the "Card number" field. The entry is made without hyphens.',
    completeUserData: 'To complete the booking, please fill in the required information (*)',
    paymentAlreadyVerified: 'The booking has already been checked.',
    total: 'Total',
    pdf: 'PDF',
    downloadPdf: 'download PDF',
    noPdfAvailable: 'This booking does not include a PDF file.',
    vouchers: 'Vouchers',
    productsAlreadyInBasket: 'Products already in shopping basket.',
    basket: 'Shopping basket',
    navigationErrorNoBasketEntriesInState: 'Add at least one product to the shopping cart or click back.',
    continueShopping: 'Continue shopping',
    currentBasketWillBeDeleted: 'The shopping cart will be deleted!',
    areYouSureDeletingBasket: 'If you log out while shopping, your shopping cart will be deleted and the current booking process will be reset. Would you like to continue?',
    notAvailable: 'There are currently no tickets available',
    dataMediaAmount: '<b>You have the following options to top up your ticket</b> <br><br>',
    dataMediumSwisspass: '<b>SwissPass</b> <br>' + '<ul>' + '<li>' + 'Camera capture: Hold the QR code of your SwissPass in front of the camera of your mobile phone/PC.' + '</li>' + '<li>' + 'Manual entry: in the "Card number" field, enter your 11-digit SwissPass number <u>including S but without</u> hyphens.<br>' + 'You will find the number on the back of your SwissPass.' + '</li>' + '<li>' + '- Camera recording: Hold the QR code of your SwissPass in front of your mobile phone\'s/PC\'s camera.<br>' + '- Manual entry: In the "Card number" field, enter your 11-digit SwissPass number including S but <u>without</u> hyphens. You will find the number on the back of your SwissPass.<br>' + '- Your ski ticket is automatically saved on your SwissPass and you can start directly on the slopes without queuing at the cash desk.',
    dataMediumSkidata: '<b>SKIDATA keycard</b> <br>' + '<ul>' + '<li>Basically, you can use any keycard from SKIDATA (also from other ski areas). To do this, enter in the field "Card number" the 23-digit ' + 'number from the front of your keycard. The entry is made without hyphens.' + '</li>' + '<li>Your ski ticket is automatically stored on this keycard and you can start directly on the slopes without queuing at the ticket office. ' + 'So that you can quickly assign the card to a person, give it a name, e.g. Keycard_Michael.' + '- Basically, you can use any SKIDATA Keycard (also from other ski resorts). Enter the 23-digit number from the front of your Keycard in the "Card number" field. The number is entered without hyphens.<br>' + '- Your ski ticket is automatically stored on this Keycard and you can start directly on the slopes without queuing at the cash desk. To enable you to quickly assign the card to a person, give it a name e.g. Keycard_Michael.',
    dataMediumPrintAtHome: '<b>Print@Home</b><br>' + '<ul><li>After placing your order, you will receive a PDF by email, which you can either print out or scan on ' + 'your cell phone directly as you pass through. A visit to the ticket counter is not necessary. You will also ' + 'find all booked tickets in your booking overview.' + '</li></ul>',
    dataMediumPickup: '<b>Pick up / Pick up on site</b><br>' + '<ul><li>After your order, you will receive a PDF by e-mail, which you must print out and present at the checkout ' + 'counter. There you will receive a KeyCard, which you should ideally keep for your next online booking.' + '</li></ul>',
    dataMediumAxess: '<b>Axess KeyCard</b><br>' + '<ul><li>Basically you can use any KeyCard from Axess (also from another ski resort). ' + 'To do this, enter the number from the back of your KeyCard in the "Card number" field. The input ' + 'is <u>with hyphen</u>.' + '</li></ul>',
    dataMediumPrintAtHomeSchnaager: '<b>Print@Home</b><br>' + 'After your order, you will receive a PDF by e-mail, which you can print out and ' + 'have to show to the Alpuschnaager driver. You can also show the pickup ticket on your smartphone.',
    onlyFewTicketsLeft: 'Maximum tickets available at this price',
    voucherAlreadyUsedInOtherBooking: 'Booking invalid. You have already used the voucher in another booking.',
    paymentForBookingNotFound: 'The payment for the booking was not found. Please contact support.',
    paymentFailed: 'The payment failed. Please try again e.g. with another credit card.',
    calculatingPrices: 'Fetching prices',
    depot: 'Deposit',
    choosingPersonForTicket: 'Select person for «{ticket}»',
    gotToBackend: 'Backend'
  },
  v6: {
    showFilter: 'Show filter',
    hideFilter: 'Hide Filter',
    noNewPrice: 'The new price could not be set because it was zero.',
    setNewPrice: 'Overwrite ticket price?',
    newPrice: 'New price (CHF)',
    // not in use
    OverwritePrice: 'Overwrite price',
    newPriceRequired: 'Please enter a new price',
    confirmOverwritePrice: 'Are you sure that the ticket price for the {date} should be overwritten with {price} CHF?',
    sure: 'You\'re sure?',
    minimalPrice: 'Minimal price',
    correctedDate: 'Your reservation took longer than our season. Therefore, we have automatically adjusted your date selection to the last possible day.',
    addCard: 'Add Swisspass / Keycard',
    addNoCard: 'Do not add a card',
    includingCardFees: 'incl. {fee} deposit',
    allBookingEntriesCancelled: 'Tickets cancelled - No PDF',
    ticketCancelled: 'Ticket has been cancelled',
    overwirteAllPrices: 'Change prices',
    priceSuccessfullyOverwritten: 'The price was successfully overwritten.',
    overwrittenPrice: 'Overwritten',
    resetPrice: 'Reset price',
    youOverwriteTheFollowingTicket: 'You overwrite the following product',
    reset: 'reset',
    dateRequired: 'No Date was selected',
    priceSuccessfullyReset: 'Price successfully reset',
    ownForecast: 'Own Forecast',
    lastUpdated: 'Last updated',
    resetOverwrittenPrice: 'Would you like to reset the manually overwritten price to the automatically calculated price?',
    base: 'basic'
  },
  discounts: { family: 'family discount' },
  moduleNames: {
    skiTicket: 'Ski ticket',
    skiTicketBellwald: 'Ski tickets',
    skiTicketVals: 'Ski ticket',
    sleddingTicket: 'Sledging ticket',
    trainRide: 'Train journey',
    trainNiesen: 'Train journey',
    tableReservationNiesen: 'Lunch table',
    hotelNiesen: 'Accomodation',
    trainReservationNiesen: 'Train reservation',
    seasonAbosBellwald: 'Season subscription',
    singleRideBellwald: 'Single trip',
    skiTicketChaeserrugg: 'Ski tickets',
    singleRideChaeserrugg: 'Single trip',
    seasonAbosChaeserrugg: 'Subscriptions',
    hikingChaeserrugg: 'Hiking tickets',
    skiMoosalpregion: 'Ski tickets',
    seasonAbosMoosalpregion: 'Subscriptions',
    singleRideMoosalpregion: 'Single journeys',
    sledgeChaeserrugg: 'Sledging tickets',
    bikeparkBellwald: 'Bikepark'
  },
  routingTitles: {
    overviewPricing: 'Overview',
    pricingDetails: 'Pricing',
    pricingSettings: 'Settings',
    pricingWeather: 'Weather',
    pricingAnalytics: 'Analytics',
    profile: 'My Profile',
    myBookings: 'My Bookings',
    myProfiles: 'User',
    myVouchers: 'Vouchers',
    bookingOverview: 'Bookings',
    extraRide: 'Train',
    stornoHistory: 'Cancellations',
    pricingTable: 'Pricetable',
    capacity: 'Capacity',
    products: 'Products',
    events: 'Events',
    cashDesk: 'Cash Desk',
    reports: 'Reports',
    settings: 'Settings'
  },
  calendar: {
    days: {
      mo: 'Mon',
      tu: 'Tu',
      we: 'We',
      th: 'Th',
      fr: 'Fri',
      sa: 'Sat',
      so: 'So'
    },
    soldOut: 'sold out',
    productNotAvailableOnDate: 'The product is not available on this date.',
    notAvailable: 'Not available'
  },
  weather: {
    weatherIn: 'Weather forecasts',
    edit: 'Change',
    title: 'Select Weather',
    changeForecast: 'Edit',
    changeWeatherConfirmation: 'Edit forecast',
    ok: 'Okay',
    nok: 'Cancel',
    acceptChanges: 'Do you want to accept the following change?'
  },
  pricingDetails: {
    percentage: '%',
    weekdayChartLabel: '% Surcharge',
    weekdayChartTitle: 'Surcharge %',
    valdemChartYLabel: 'Surcharge chf',
    dates: 'Dates',
    filterChoice: 'Filter Options',
    days: 'Weekday',
    weekdays: 'Weekdays',
    seasonPhases: 'Seasonal phase and public holidays',
    priceCombo: 'Price (CHF)',
    // not in use
    totalPrice: 'Overall Price',
    valDem: 'Value',
    value: 'Value',
    demand: 'Demand',
    dailyBaseRate: 'Daily Base Rate',
    multiDayDiscount: 'Multi-Day Discount - Product Target Price',
    maximumEarlyBooking: 'Current Early Booking Discount',
    cashDeskPrice: 'Cash Desk Price'
  },
  productSelector: {
    noProductsAccess: 'No products',
    loadingProducts: 'Fetching products...'
  },
  weekdays: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday'
  },
  footer: {
    links: 'Links',
    acceptedPayments: 'Means of payment',
    contact: 'Contact',
    poweredBy: 'powered by'
  },
  apiPage: {
    notFound: 'Not Found',
    notFoundDesc: 'The requested page does not exist'
  },
  attributes: {
    region: 'Region',
    age: 'Person type',
    duration: 'Duration',
    flex: 'Flex/Basic',
    performanceDiff: 'Performance differentiation',
    room: 'Room',
    train: 'Train ride',
    adults: 'Adults',
    children: 'Children',
    route: 'Route',
    from: 'From',
    to: 'To',
    swisspass: 'Discount',
    time: 'Time',
    personAmount: 'Headcount',
    trainAdults: 'Journeys Adults',
    trainChildren: 'Journeys Children',
    meal: 'Meal',
    tarif: 'Rate',
    voucherType: 'Voucher type',
    warningTexts: { gaHalbtax: { niesen: 'All reductions (GA or Halbtax) will be applied at the end of the booking process.' } }
  },
  performanceDiffAdvantages: {
    ski: 'Ski ticket',
    flexibility: 'flexibility',
    cancellation: 'Cancellation'
  },
  performanceDifferentiation: { outOfDays: '{durationDays} from {durationDaysPlus} days' },
  emergencyDown: { text: 'Please excuse the interruption. We are currently making an update and will be back for you shortly.' },
  extraRides: {
    extraRides: 'Train',
    fromDate: 'from',
    toDate: 'to',
    name: 'Ride',
    date: 'Date',
    ascent: 'Ascent',
    ascentTime: 'Ascent time',
    descent: 'Descent',
    descentTime: 'Descent time',
    addedBy: 'Added by',
    updatedAt: 'Added on',
    comment: 'Comment',
    edit: 'Edit',
    noDataAvailable: 'No train data',
    newExtraRide: 'Capture train journey',
    editExtraRide: 'Edit train journey data',
    applyExtraRide: 'Save train journey',
    applyChanges: 'Apply changes',
    deleteExtraRide: 'Delete train journey',
    confirmDeletion: 'Do you really want to delete this train journey?',
    cancelEditing: 'Cancel',
    newExtraRideSuccessfull: 'New train journey successfully captured',
    deletionSuccessfull: 'Train journey deleted',
    editSuccessfull: 'Changes successfully applied',
    updateNotSuccessfull: 'Train journeys can not be loaded',
    editNotSuccessfull: 'Selected train journey can not be loaded',
    deletionNotSuccessfull: 'Deletion failed',
    descDateError: 'Descent date can not be smaller than ascent date',
    ascentDateNotSet: 'Please set a date for the ascent',
    ascentTimeNotSet: 'Please set a time for the ascent',
    descentDateNotSet: 'Please set a date for the descent',
    descentTimeNotSet: 'Please set a time for the descent'
  },
  shopBackendBookingOverview: {
    all: 'All',
    aggregated: 'Aggregated',
    byCustomer: 'By Customer',
    date: 'Date',
    product: 'Product',
    personCount: 'Number of people',
    customer: 'Customer',
    time: 'Time',
    bookingState: 'Booking State',
    remark: 'Remark',
    customerSearch: 'Customer Search',
    searchDefaultText: 'Search by first name, last name, city',
    tooManyWords: 'Not more than four words allowed',
    noSearchResult: 'No Search Result',
    ticketCount: 'Tickets in this booking',
    validity: 'validity',
    bookingsOfTheUser: 'The users bookings',
    calendar: 'Calendar'
  },
  shopBackendBookingDetail: {
    buyer: 'Buyer',
    missingId: 'This page does not exist! No booking ID available',
    remark: 'Remark',
    bookingState: 'Booking State',
    paymentDetails: 'Payment Details',
    name: 'Name',
    ticket: 'Ticket',
    price: 'Price',
    save: 'Save',
    cancelMarkedTickets: 'Cancel Marked Tickets',
    receivedMoney: 'Encash amount',
    printAllTickets: 'Tickets',
    paymentState: 'Payment status',
    cancelTicket: 'Cancel',
    abort: 'Abort',
    cancellationAgreeText: 'Do you really want to cancel the selected tickets?',
    tickets: 'Tickets of this booking',
    bookingStateWaitingList: 'Waiting list',
    bookingStateProvisionally: 'Provisionally',
    bookingStateManualConfirmed: 'Confirmed (by employee)',
    bookingStateAutoConfirmed: 'Confirmed (in the shop)',
    bookingStateDefinitive: 'Confirmed',
    paid: 'Paid',
    notPaid: 'Not paid',
    cancellationFaildForUnknownReason: 'The cancellation failed for an unknown reason.',
    cancellationWasSuccessful: 'The cancellation was successful',
    validFrom: 'Valid from',
    skidataLockNumber: 'Lock number',
    dataMedium: 'Medium',
    doNotForget: 'Don\'t forget',
    cancellationGenerallyOk: 'Vochers were generated.',
    thirdPartySystemCancellationFailed: 'We were unable to automatically cancel some tickets in a third party system. ' + 'At Skidata you can try the reservation number or the blocking number.',
    system: 'System',
    ticketsUnCancelableAsNotPaid: 'Tickets cannot be cancelled because the booking is unpaid.',
    fromCity: 'from',
    noRemark: 'No remark'
  },
  shopBackendBookingComplete: {
    day: 'Day',
    fourDay: '4 Days',
    week: 'Week',
    month: 'Month',
    timePeriod: 'Query period',
    product: 'Product',
    productDefinition: 'Details',
    customer: 'Customer',
    time: 'Time',
    bookingState: 'Booking status',
    remark: 'Remark',
    extraTrip: 'Extra trip',
    addBooking: 'Add booking',
    xlsx: 'Export list',
    peopleCount: 'Number of people',
    capacity: 'Capacity',
    today: 'Today',
    chooseDateRange: 'Query Period',
    dateRangeDescription: 'Select a single date or a start and an end date',
    expand: 'Expand',
    aggregatedBookings: 'Aggregated-Bookings',
    bookingDate: 'Booking date',
    paymentTime: 'Payment time',
    mail: 'E-mail'
  },
  skidata: {
    unknownState: 'Unknown state',
    ok: 'State: ok',
    cancellationSuccessfull: 'Successfuly cancelled',
    unpaidNotInSkidata: 'Unpaid but not in external ticket provider.',
    failedToCancelButInSkidata: 'Failed to cancel in external ticket provider.',
    failedToWriteToSkidata: 'Error writing to external ticket provider.',
    state: 'State',
    pickupCode: 'Ticket barcode',
    noBarcode: 'This ticket has no Barcode',
    orderId: 'Reservationnumber',
    keycardHasToStartWith01: 'The number has to start with 01',
    invalidCard: 'Invalid card number'
  },
  pricingTable: { askAtTheCashDesk: 'see cash desk' },
  infoText: { vals: { ageRestrictions: 'Children and young people born in 2004 or younger can obtain a ' + 'personalized season pass. With this card you can pass the turnstile the whole season. ' + 'Children\'s one-day free tickets are available at the valley station of the cable car.' } },
  shortCutTrainRide: {
    departure: 'Departure place',
    destination: 'Destination',
    selectDeparture: 'Please select a departure place',
    selectDestination: 'Please select a destination',
    selectRoute: 'Please make your choice',
    hikingHint: 'Drive 3 stations, walk 1 station.',
    selectDate: 'Choose your date'
  },
  shortCutTrainReservation: {
    infoBox: 'Reservations are only possible until 6:00 a.m. on the day of validity. However, you can also use the ' + 'funicular without a reservation. Without a reservation, there may be waiting times on peak days.',
    chooseDate: 'Select date'
  },
  shortCutTableReservation: {
    time: 'Select time',
    selectTime: 'Please select your time',
    selectDate: 'Choose your date'
  },
  selectMedium: {
    reduction: 'Select reduction',
    selectReduction: 'Swiss General Abonnement or Half-Fare travelcard?',
    selectTarifReduction: 'Are you a local and do you have the appropriate identification?',
    isNotASwisspass: 'The selected Card is not a Swisspass',
    swisspassDataNotUpdated: 'Swisspass could not be updated',
    swisspassHasNoGaOrHalfFare: 'Your Swisspass has no valid General Abonnement or Half-Fare travelcard',
    swisspassHasNoGA: 'Your Swisspass does not have a valid GA',
    swisspassHasNoHalfFare: 'Your Swisspass does not have a valid Half-Fare travelcard',
    productForPerson: '{product} for {person}',
    completeBirthdate: 'Please complete the date of birth',
    preparingBasket: 'Your shopping cart is being prepared. It will go on in a moment.',
    customBellwaldLocalNotification: 'The local fare is only available upon presentation of the official blue ID. ' + '(or a confirmation of residence) is granted. It must be issued after 1 September of the current year.',
    customChaeserruggLocalNotification: 'Locals of the community Wildhaus - Alt St. Johann benefit from a ' + 'Special Rate. You hereby confirm that you are in possession of a valid local resident\'s identity card of the municipality of ' + 'Wildhaus - Alt St. Johann and are able to present this on request.',
    customMoosalpregionLocalNotification: 'You hereby confirm that you are resident in the canton of Valais ' + 'and, in the case of a sample, be able to prove this on the basis of the confirmation of residence.',
    customMoosalpregionGuestNotification: 'I confirm that I am in possession of a valid guest card and that ' + 'can present them at any time. Spot checks may be carried out.',
    nonRefundable: 'Card fee'
  },
  productsOverview: {
    editProducts: 'Edit products',
    edit: 'edit'
  },
  singleProductView: {
    editProduct: 'Edit product',
    vat: 'VAT',
    capacity: 'Capacity',
    editCapacity: 'Edit capacities',
    capacityCalendar: 'Capacity overview',
    productImage: 'Product Image',
    selectAProductImage: 'Choose a product image',
    maxImageSize: 'Max image filesize 1MB',
    uploadingFailed: 'Uploading has failed!',
    uploadingImage: 'Uploading image ...',
    imageDescription: 'Recommended aspect ratio of 3:2. The allowed image formats are .jp(e)g and .png',
    simpleProductImage: 'Single Image',
    productDefImage: 'Multiple Images',
    chooseProdDef: 'Select a product characteristic.',
    productPresentation: 'Present your products',
    productOverall: 'Product general',
    productCharacteristics: 'Product characteristics',
    bookableDates: 'Product Availability',
    activeAfterNextPriceCalculation: 'Note: The settings will become active after the next price calculation.',
    activate: 'Publish product',
    deactivate: 'Deactivate product',
    productIsDeactivated: 'The product is currently inactive and therefore not available in the shop',
    errorUpdatingActive: 'Error when updating the status',
    additionalProductHasNoCapacities: 'Comparison product has not defined capacities.'
  },
  productCapacity: {
    mapCapacityOnAttributes: 'By specification',
    mapCapacityOnProduct: 'By product',
    capacityAmount: 'Capacity',
    addCapacityAmount: 'Enter the capacity',
    capacityForProduct: 'Maximal daliy capacity for the product {product}',
    deleteAllCapacities: 'Delete capacities',
    reallyDelete: 'Really delete?',
    allCapacitiesWillBeDeleted: 'All capacities of this product will be deleted. You can not undo this action.',
    editCapacity: 'Edit capacity',
    capacityUpdatedSuccessfully: 'Changes saved.',
    capacityDeletedSuccessfully: 'Capacities deleted.',
    capacityCreatedSuccessfully: 'Capacity created.',
    capacitySpecification: 'Product specification',
    selectCapacitySpecification: 'Chose a product specification',
    attributeValue: 'Value',
    selectAttributeValue: 'Select a value.',
    capacityForAttribute: 'Maximum capacity for "{attributeValue}"',
    capacityAttributeWrong: 'The capacity settings do not match the values of the pricing engine. ' + 'This leads to incorrect data in the entire application.'
  },
  capacityCalendar: {
    overrideCapacity: 'Override the max capacity for {attributeOrProduct}.',
    selectOverrideCapacity: 'Edit capacity',
    selectEditEvent: 'Edit event',
    startDateRequiredSmaller: 'Start date has to be smaller than the end date!',
    override: 'Override',
    whatDoYouWantToDo: 'How would you like to proceed?',
    showCapacitySibling: 'Show comparison product',
    disableCapacitySibling: 'Hide product',
    showRuleBased: 'Show more options',
    hideRuleBased: 'Show less',
    newCapacity: 'New maximum capacity for selection',
    showAll: 'Show all'
  },
  valueCapacity: {
    updateCapacity: 'Overwrite capacity',
    capacityUpdated: 'Capacity overriden',
    capacityNotUpdated: 'We were not able to override the capacity.'
  },
  personAdder: {
    checkForAvailability: 'We are looking for the availability',
    availableTickets: 'Sold out | Only 1 left | {stockLeft} still available',
    soldOut: 'Sold out. We are sorry, but there ar no more tickets left.',
    ticketsSoldOutRemoved: 'Unfortunately the ticket of your choice is sold out.',
    noFreeTable: 'There is no table available at this time, choose another time.',
    selectAttribute: '{attribute} select',
    basketConditions: {
      min: 'Add {attributeTitle} at {count}x in the cart.',
      max: 'Add {attributeTitle} maximum {count}x in the cart'
    }
  },
  shopComment: {
    textFieldLabel: { trainRideNiesen: 'Remarks or wishes to the Niesen team' },
    adminNote: {
      trainRideNiesen: 'Requests for space cannot be guaranteed.',
      tableReservation: 'The ascent takes 30 minutes, seat requests cannot be guaranteed.'
    },
    maxCharacter: 'A maximum of 240 characters is allowed.'
  },
  product: {
    bookingOnlyTill: 'Booking not possible. The reservation must be made by {bookingTill} at the latest. Please select a later date.',
    callForBooking: 'Booking online only possible until {bookingTill} am. For short term bookings, please call {phoneNumber}.',
    eventsCouldNotBeLoaded: 'Events could not be loaded.',
    loadingEvents: 'Fetching events',
    failedLoadingAdditionAttr: 'Failed loading additional attributes',
    loadingValidityDates: 'Loading product availability',
    updatingValidityDates: 'Adjusting product availability',
    errorUpdatingValidityDates: 'Failed to update product availability',
    updatedValidityDates: 'Product availability successfully updated',
    sureToUpdate: 'Are you sure you want to update the product availability?',
    noBookingDateLeft: 'The product is sold out until the end of the season!',
    pricesCouldNotBeLoaded: 'Prices could not be loaded.'
  },
  shortCutHotel: { chooseArrivalDate: 'Choose arrival date' },
  stepperModal: { niesen: { seatReservationModalText: 'Seats in the lane are limited. ' + 'With a train reservation we guarantee you a seat on the train at the selected time.\n' + '<br>If you have made a train reservation, we ask you to contact us no later than ' + '<br>If you have made a funicular reservation, we ask you to arrive at the <b>group entrance with your reservation</b>' + ' (print or on your mobile phone) <b>at least 10 minutes</b> before the departure.\n' + '<br>Otherwise we cannot guarantee your funicular reservation. \n' + '<br>Please note that you will need a <b>regular train ticket</b> in addition to your reservation.\n' } },
  hotelRoomSelector: {
    moreInformation: 'More information',
    addToBasket: 'Add to basket',
    roomAddedSuccessfully: 'Room added',
    moreDetails: 'More Details'
  },
  singleEventView: {
    editEvent: 'Edit event',
    createEvent: 'create event',
    eventTemplate: 'Event template',
    selectEventTemplate: 'Please select an event template',
    eventDate: 'Event date',
    selectEventDate: 'Please select an event date',
    eventTitle: 'Title',
    eventLead: 'Short description',
    eventDescription: 'Detailed description',
    eventTitleRequired: 'Please fill in a title.',
    eventLeadRequired: 'Please enter an event lead.',
    eventDescriptionRequired: 'Please describe the product.',
    removeEventFromShop: 'Remove event from shop',
    publishEvent: 'Save & Publish',
    eventIsPublished: 'Event is published in the shop.',
    eventIsUnpublished: 'Event is unpublished and hence not visible in the shop.',
    eventStartTime: 'Event start',
    eventEndTime: 'Event end',
    eventStartMandatory: 'Start time is mandatory.',
    eventEndMandatory: 'End time is mandatory.',
    timeIncomplete: 'Please provide the following time format hh:mm',
    editDescription: 'Event description',
    editPricing: 'Pricing',
    selectEventImage: 'Select an event image',
    eventImage: 'Event picture',
    presentEvent: 'Describe your event',
    eventData: 'Event dates',
    iconText: 'Icon Text',
    iconTextRequired: 'Please enter an icon text.',
    iconRequired: 'Please select icon',
    iconsTitle: 'Icons',
    noIcons: 'No icons in use',
    eventNotDeleted: 'Event could not be deleted because it was already posted to.',
    deleteEvent: 'Delete event',
    reallyDeleteHeader: 'Delete event really?',
    reallyDeleteText: 'This deletion cannot be undone. The event cannot be restored.',
    overrideTime: 'Change time',
    reallyOverrideTime: 'Time really change?',
    explainTimeChange: 'Guests who have already booked the event will NOT be notified of the time change.'
  },
  event: {
    faildToCreate: 'An error occoured: Event not created!',
    eventCouldNotBeLoaded: 'Event could not be loaded.',
    createdNewEvent: 'Event created',
    eventNotUpdated: 'Changes could not be saved!',
    eventUpdated: 'Changes saved.'
  },
  events: { eventsCouldNotBeLoaded: 'Events could not be loaded!' },
  entityTranslation: { entityNotCreated: 'Translation could not be saved!' },
  createBookingOverview: {
    createNewBooking: 'Book',
    cancelBooking: 'Cancel booking',
    atLeasOneBasketEntryRequired: 'At least one basket entry required.',
    confirmAndBook: 'Confirm booking',
    bookingConfirmation: 'Booking confirmation',
    customerPayed: 'Money in!'
  },
  createBooking: {
    selectProductOrEvent: 'Product or event',
    availableCapacity: 'Capacities',
    amountOfProducts: 'Amount in the basket',
    composeProduct: 'Select date and product',
    selectPerson: 'Select customer',
    addToBasket: 'Add to basket',
    productOrEventMandatory: 'Select product or event.',
    amountMandatory: 'Insert amount.',
    productOrEventShort: 'Product/Event',
    insufficientCapacities: 'Insufficient capacities. You may overwrite the corresponding daily capacity or set the booking state to waiting list.',
    waitingList: 'Set to waiting list',
    noSuchProductCombination: 'This combination does not exist. Please correct.',
    incl: 'Inclusive',
    changeBooking: 'Should the booking be made for another main customer? Then you must empty the shopping cart or enter a new booking.',
    hint: 'Hint: You can assign the individual tickets to another user at the bottom of the shopping cart.',
    productDetails: 'Product details',
    productSoldOut: 'The product is fully booked for this number of people.',
    selectProduct: 'Select a product',
    dateNotAvailableForSelectedProduct: 'The requested product is not available for the selected day. We have adjusted the date automatically.',
    eventNotAvailableOnThisDate: 'The event is not available on this date!',
    saveChanges: 'Save change'
  },
  bookingByCustomerSearch: {
    userHasBookings: '{user} has no bookings so far. | {user} has already {bookings} bookings. Show. | {user} has already {bookings} bookings. Show.',
    hideBookings: 'Hide bookings',
    unpaid: 'Unpaid'
  },
  bookingConfirmation: {
    arrivalTime: 'Arrival time (about)',
    bookingStateMandatory: 'Please select a booking state',
    sendMail: 'Send booking confirmation',
    doNotSendMail: 'No booking confirmation',
    internalRemark: 'Remark (internal)',
    selectPerson: 'Select Person',
    thisIsTheBookingPerson: 'Booking for this person.',
    confirmationForThisPerson: 'Mail confirmation will be sent to this person.',
    bookingUser: 'Booking for',
    mailRequired: 'Missing mail for the selected person.'
  },
  sTextEditor: { contentRequired: 'Please enter a text.' },
  adminCheckout: {
    checkoutFailed: 'The booking failed!',
    sendingMailFailed: 'The booking confirmation could not be sent!',
    bookingCreated: 'Booking created.',
    confirmationMailSent: 'Booking confirmation sent.',
    capacitySoldOut: 'Someone beat you to it. One of your products has been sold out in the meantime. The booking was not created!',
    productInactive: 'One of the products in the shopping cart has been made inactive in the meantime and can therefore no longer be booked.'
  },
  bookingState: {
    change: 'Change state',
    changeBookingState: 'Do you want to change the booking state?',
    undoImpossible: 'This change can not be undone!',
    stateChanged: 'Booking state changed'
  },
  bookingStates: { stateCouldNotBeChanged: 'The booking state could not be changed. The capacity limitations may be reached.b' },
  paymentDetails: {
    customerPaid: 'Customer paid',
    didCustomerPaid: 'Amount cashed',
    amountReceived: 'Received the amount over <span class="font-weight-black">{amount}</span>.',
    changeBookingStateFirst: 'Change booking status to collect amount!',
    printGroupReceipt: 'Group receipt',
    groupDiscounts: 'Group discounts',
    payCashFromShopForbidden: 'Unpaid shop booking'
  },
  groupReceipt: {
    groupReceipt: 'Booking receipt',
    peopleCount: 'Amount of people: {peopleCount}',
    group: 'Group'
  },
  printTickets: {
    printTickets: 'Print tickets',
    valid: 'Valid',
    barcodeError: 'Error: Barcode could not be generated.',
    reason: 'Reason',
    novatouchError: 'Novatouch error',
    co2Compensation: 'carbon offset',
    cwcExplanation: 'More information at causewecare.ch',
    bookingNumber: 'Booking no. {bookingNumber}',
    niesenReservationHint: 'Please be at the group entrance 10 minutes before departure (follow the signposts). ' + 'Note that you also need a regular train ticket.'
  },
  priceBulkManagement: {
    gotoBtn: 'Override prices',
    editRules: 'Define Rules',
    surcharge: 'Percentage price change',
    absoluteSurcharge: 'Absolute price override',
    chooseProducts: 'Choose Products',
    surchargeModeAbs: 'Overwrite selected products with absolute amount',
    surchargeModePerc: 'Percentage price increase or decrease',
    amount: 'Amount',
    percent: 'Percent',
    resetPrices: 'Reset Prices',
    reset: 'Reset',
    submit: 'Submit',
    repeat: 'Repeat',
    repeatEvery: 'Repeat every',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    preview: 'Single Selection / Preview',
    explanation: 'In addition to the rule-based selection, you can also manually add/remove data.',
    youAreOverriding: 'Override Prices',
    overwritePrice: 'Override Prices',
    youOverridePrices: 'You are about to override the following prices',
    priceChange: 'Percentage price change for all selected products',
    absoluteChange: 'New price for all selected products',
    priceReset: 'The price will be reset to the default value for all selected products',
    atDates: 'On the dates',
    resetPricesTitle: 'Reset Prices',
    youResetPrices: 'You are about to reset the prices',
    repeatEveryWeekday: '-nth weekday',
    overwrite: 'Overwrite',
    failedOverwriting: 'Failed overwriting the prices',
    failedReverting: 'Failed reverting the prices',
    failedLoadingCustomPrices: 'Failed loading custom prices',
    successOverridePrices: 'Successfully updated prices',
    successResetPrices: 'Successfully reverted prices',
    newPrice: 'New Custom Price',
    oldPrice: 'Current Posted Price',
    priceDifference: 'Difference',
    calculating: 'Calculating Prices, this might take a while ...',
    product: 'Product',
    filter: 'Filter products...',
    overrideWithZero: 'Attention! The price will be overwritten with 0. Are your sure to continue? '
  },
  shopBookingCalendar: {
    selectProducts: 'Select Products',
    others: 'others'
  },
  shopOverview: {
    noProductDefinitionProvided: 'No matching product found.',
    scrollHint: 'Scroll to view more experiences',
    groupRequests: 'Group requests'
  },
  bookingComplete: {
    excelDownload: 'Export List',
    bookings: 'Bookings',
    people: 'People'
  },
  datePersonCarousel: {
    available: 'Only {capacities} available',
    selectAmountOfPeople: 'Choose number of people',
    loadingSelection: 'Please wait...',
    maxAvailableTickets: 'Seats sold out | max. 1 seat available | max. {stockLeft} seats available',
    availableTickets: 'Seats sold out | 1 seat available | {stockLeft} seats available'
  },
  basket: {
    peopleCount: '{peopleCount} Person | {peopleCount} Persons',
    sledgeCount: '{peopleCount} Sledge | {peopleCount} Sledges',
    dogCount: '{peopleCount} Dog | {peopleCount} Dogs',
    checkout: 'Checkout',
    addBasketEntries: 'Please put your desired products into the shopping cart.',
    causeWeCareNotUpdated: 'Unfortunately the CO2 compensation could not be added.',
    inclCo2Compensation: 'Incl. CO2 compensation',
    causeWeCare: 'Cause We Care',
    add: 'Add',
    requiredEntryCannotBeDeleted: 'This product cannot be removed because it belongs to another product in the shopping cart.',
    offered: 'Offered',
    nonRefundableCardFee: 'incl. {fee} card fee'
  },
  productPresenter: {
    start: 'Start',
    end: 'End',
    unfold: 'Further information',
    fold: 'Less information',
    jumpToDate: 'Select date'
  },
  productCategories: {
    train: 'Rail travel',
    tableReservation: 'Table reservations',
    gastro: 'Culinary offers',
    events: 'Event Templates',
    rooms: 'Seminars',
    required: 'Required',
    hotel: 'Hotel',
    request: 'Inquiries',
    requestForm: 'Group requests',
    niesenExclusive: 'Exclusive',
    reservation: 'Reservations',
    seasonabo: 'Season tickets',
    voucher: 'Vouchers',
    ski: 'Ski',
    singlerides: 'Single journeys',
    crowdFunding: 'Crowdfunding',
    winterabo: 'Winter cards',
    winterAbo: 'Winter cards',
    summerabo: 'Summer Pass',
    yearabo: 'Annual tickets',
    pistenBully: 'Alpuschnaager',
    points: 'Scorecards',
    sledge: 'Sledging tickets',
    pedestrian: 'Pedestrian',
    hiking: 'Hiking tickets',
    bikepark: 'Bikepark',
    summerOffers: 'Summer Offers',
    experiences: 'Experiences',
    winteraboSki: 'Annual Ski Pass',
    yearaboPedestrian: 'Annual Pedestrian Passes',
    sendingcostPerBooking: 'Shipping costs',
    insurance: 'Insurance',
    transportInPackage: 'Transport',
    printse: 'Printse',
    '4_vallées': '4 Vallées',
    fee: 'Shipping costs',
    summeraboNendaz: 'Summer pass',
    winteraboSkiNendaz: 'Annual passes (winter + summer 2023)',
    yearaboPedestrianNendaz: 'Pedestrian pass (winter + summer 2023)',
    royalrides: 'Royal Ride',
    promotions: 'PhD'
  },
  adminBasket: {
    groupDiscount: 'Group discount',
    createGroupDiscountFailed: 'Group discount could not be created.',
    discountType: 'Discount type',
    discountDescription: 'Discount description',
    selectDiscountType: 'Select discount type',
    provideDiscountDescription: 'Please provide a description',
    insertDiscountAmount: 'Please insert an amount',
    couldNotDeleteGroupDiscount: 'Group discount could not be deleted.',
    netWithoutVat: 'Net excluding VAT',
    vat: 'VAT',
    totalInclVat: 'Total incl. VAT',
    incl: 'Incl.',
    withCauseWeCare: 'With CO2 compensation',
    withoutCauseWeCare: 'Without CO2 compensation',
    fetchingBasketFailed: 'Basket could not be fetched.',
    addProduct: 'Add product',
    saveChanges: 'Save changes'
  },
  discountTypes: {
    absolute: 'Absolute (CHF)',
    // not in use
    relative: 'Relative (%)'
  },
  contactForm: {
    yourMessage: 'Your message',
    messageRequired: 'Please enter your request.'
  },
  sendRequest: {
    summary: 'Summary',
    sendRequest: 'Send request',
    request: 'Request',
    senderContact: 'Sender\'s Contact:'
  },
  formRequest: {
    sendingFailed: 'The message could not be sent',
    requestSent: 'Your message was delivered to us.'
  },
  bookingsComplete: { roomNumber: 'Room number' },
  bookingEntry: { saveAllocationNumberFailed: 'The allocation could not be saved.' },
  checkoutNavigation: {
    compensateCo2: 'Compensate for CO2',
    payNow: 'Pay now',
    capacitySoldOut: 'Someone beat you to it. One of your products has been sold out in the meantime. ' + 'Your booking could not be completed. Your account was not charged.',
    productInactive: 'One of the products in your shopping cart is no longer available.',
    accommodationTax: 'Please pay visitor\'s tax/accommodation tax at the Berghaus',
    voucherNotValidated: 'The voucher you specified has not yet been added. Add it or ' + 'or remove it to continue.',
    niesen: {
      oldVoucherTitle: 'Redeeming the old Niesen voucher - made easy',
      oldVoucherText: 'To redeem an older voucher (see photo) online, you can enter the QR code (see red outline on the photo) with a ' + 'Scan cell phone camera. The cell phone camera will give you a code ' + 'display. You can enter this code in the field above ' + '("Enter online credit code"). ' + '<b>The printed booking number cannot be entered online.</b>'
    }
  },
  imageUploader: {
    required: 'You must choose a file',
    wrongFileType: 'Only .png and .jpg are supported'
  },
  singleReport: {
    noContent: 'No content',
    roomNumber: 'Room number',
    details: 'Details',
    total: 'Total',
    peopleOverAll: 'Person (over all)',
    totalPeople: 'People',
    reservations: 'Reservations',
    events: 'Events',
    event: 'Event',
    groups: 'Train',
    product: 'Service',
    maxPlaces: 'Reserved/Max. number',
    noLimitation: 'No limitation',
    tel: 'Tel.'
  },
  extendedAttribute: { saveFailed: 'Save failed' },
  salutation: {
    m: 'Mr',
    f: 'Ms'
  },
  settingsOverview: {
    manageRoles: 'Manage roles',
    productsImport: 'Import products',
    changeCurrency: 'Change currency',
    axessSeasonCreation: 'Initialize new season at Axess',
    powerBi: 'Manage Power BIs'
  },
  powerBiManagement: {
    noDataAvailable: 'There are no Power BIs for this region.',
    connectPowerBis: 'Which role may see which BI?',
    editPowerBis: 'Create BI'
  },
  UsersRoles: { couldNotBeLoaded: 'Users could not be retrieved.' },
  roleManagement: {
    user: 'User',
    role: 'Role',
    addNewRole: 'Assign a role to a new user',
    userAlreadyAdded: 'Selected user has already assigned roles. You will find his name above in the list.'
  },
  roles: {
    couldNotBeLoaded: 'Roles could not be retrieved.',
    couldNotBeLinked: 'Role could not be added to the user!',
    couldNotBeDeleted: 'Role could not be withdrawn from the user!'
  },
  shopHandler: { shopClosed: 'The online shop is currently closed.' },
  paymentTotalListing: {
    taxNr: 'Tax number',
    cancelledServices: 'Cancelled services'
  },
  bookingAggregated: { noCapacityLimit: 'No capacity limitation' },
  pricingOverridePrices: { notInValidityDates: 'The product is not available on all your selected days. Unavailable days will be ignored in the price override!' },
  eventSection: { knowMore: 'Learn more' },
  sectionTitle: {
    events: 'Unique events',
    customService: 'Tailor-made offers',
    extraordinaryExperiences: 'Extraordinary mountain experiences',
    requests: 'Requests'
  },
  bookingPaid: { backToCashDesk: 'Back to checkout' },
  fontAwesomeSelect: { selectLabel: 'Icon' },
  appHeader: {
    goToBackendShop: 'Into the shop backend',
    goToBackendPe: 'To the pricing engine'
  },
  translationIcons: { addIcon: 'Add icon' },
  fileUploadService: {
    processingExcel: 'Products are imported. This may take a while.',
    importSucceed: 'Product import was successful!'
  },
  productsImport: {
    fileInputLabel: 'Select Excel',
    required: 'Please select an Excel file that can be imported.',
    wrongFileType: 'Only .xlsx file format supported',
    upload: 'Upload',
    reallyImport: 'Overwrite products?',
    importCannotBeUndone: 'The products and their properties are irretrievably overwritten. This process' + ' cannot be undone!',
    overwrite: 'Overwrite',
    selectDestination: 'Choose a destination',
    wrongFileName: 'File name does not match the area name.'
  },
  changeCurrency: {
    changeLable: 'Change currency',
    currency: 'Currency',
    currencyNotEmpty: 'A currency must be set.',
    changeSuccess: 'Currency was successfully changed.'
  },
  reportsOverview: {
    bookings: 'Export Accounting / Cause We Care',
    bookings_filename: 'Bookings_Cause_We_Care_',
    cwc: 'CWC',
    accounting: 'Bookings',
    from: 'From',
    to: 'By',
    required: 'Requires',
    export: 'Export',
    loadingDataFailed: 'Error when loading CWC/booking data',
    idBooking: 'ID of the total posting',
    vat: 'VAT on CWC (7.7%)',
    cash: 'Checkout',
    six_saferpay: 'SIX',
    moreOrEquals: '"To" must be greater than or equal to "From".',
    lessOrEquals: '"From" must be less than or equal to "To".',
    noData: 'No data in the selected period',
    accountingHeaders: {
      bookingId: 'ID of the total posting',
      bundelId: 'ID of the product bundle',
      id: 'ID of the individual product (within the bundle)',
      product: 'Product',
      productDefinition: 'Details',
      customer: 'Customer',
      mail: 'E-mail',
      start: 'Validity start',
      end: 'End of validity',
      state: 'Booking status',
      paymentType: 'Payment method',
      note: 'Comment',
      currency: 'Currency',
      netPrice: 'Net amount',
      grossPrice: 'Amount gross',
      vat37: 'VAT 3.7%',
      vat77: 'VAT 7.7%',
      cancelAmount: 'Cancellation',
      cancelDate: 'Cancellation date',
      clearedNetPrice: 'adjusted amount net',
      clearedGrossPrice: 'adjusted gross amount',
      clearedVat37: 'adjusted VAT 3.7%',
      clearedVat77: 'adjusted VAT 7.7%',
      bookingDate: 'Booking date',
      paymentTime: 'Payment time'
    }
  },
  seatReservation: {
    stepperHeaderText: 'Railway reservation',
    earlier: 'formerly',
    later: 'later',
    reserveNow: 'Reserve now',
    seatsAvailable: 'seats available',
    warningText: {
      niesen: 'Without a reservation, there may be waiting times on peak days.',
      moosalpregion: 'We cannot guarantee you a seat in the Alpuschnaager without a reservation.'
    },
    soldOut: {
      moosalpregion: 'All seats are sold out. Without reservation the ride is not guaranteed and long waiting times are possible.',
      niesenTooLate: 'Reservations are only possible until 6:00 a.m. on the day of validity. However, you can also use the ' + 'funicular without a reservation. Without a reservation, there may be waiting times on peak days.',
      niesen: 'Train reservations are no longer possible for the selected date. However, you can also use the ' + 'funicular without a reservation. Without a reservation, there may be waiting times on peak days.'
    },
    productTexts: {
      niesen: [
        'Mountain ride',
        'Downhill'
      ]
    },
    selectTime: 'find time',
    inTo: 'In the',
    continueWithoutReservation: 'Continue without reservation',
    youWillRedirectedShortly: 'Check reservations. They will be forwarded immediately.',
    nextStepAnyway: 'Nevertheless further'
  },
  products: {
    overrideFailed: 'The capacities could not be changed.',
    capacitiesOverriden: 'The capacities have been changed.',
    capacityOverrideTakesAWhile: 'The capacities are overwritten. This can take several minutes.',
    archive: 'Archive'
  },
  capacityOverride: {
    noDatesSelected: 'Select the days of the week in the calendar on which the capacity is to be changed.',
    setCapacityAmount: 'Enter new capacity.',
    noCapacitiesSelected: 'Select capacities.',
    reallyChange: 'Really change capacities?',
    willBeOverwrittenOn: 'On the following dates'
  },
  capacityBellowWarning: { bellowWarning: 'Capacity under bookings' },
  shortCutSeasonAbos: {
    summer: 'Summer',
    winter: 'Winter',
    family: 'Season tickets families',
    selectSeasonMandatory: 'Bitte wähle die Jahreszeit für Dein Abo',
    selectSeason: 'Jahreszeit für Abo wählen',
    pointCards: 'Scorecards'
  },
  shortCutSledge: { selectRoute: 'Choose route' },
  seasonAbos: {
    bookNow: 'Book now',
    noProductAvailable: 'No product available on this date.'
  },
  priceHistory: {
    viewTitle: 'Historical price development',
    timespan: 'Time span',
    sevenDays: 'Last 7 days',
    fourteenDays: 'Last 14 days',
    thirtyDays: 'Last 30 days',
    seasonStart: 'Since the start of the season',
    all: 'All',
    skiDay: 'Ski day',
    priceHistory: 'Price history'
  },
  currentPostedPricesChart: {
    ylabel: 'Price',
    lastCalcDate: 'Last price calculation'
  },
  dailyBaseRateChart: {
    ylabel: 'Daily Base Rate in',
    overlayText: 'Daily Base Rate:'
  },
  productTargetPriceChart: { ylabel: 'Product Target Price' },
  cashDeskPriceChart: { ylabel: 'Cash Desk Price' },
  multiDayDiscountChart: {
    ylabel: 'Target Product Price',
    overlayText: 'Daily Base Rate: CHF',
    // not in use
    multiDayDiscountLabel: 'Multi Day Discount',
    productTargetPrice: 'Target Product Price',
    currentPostetPrice: 'Current Posted Price'
  },
  maxEarlyBookingChart: {
    ylabel: 'Current Posted Price',
    factorAxis: 'Current Early Booking Discount',
    priceAxis: 'Current Posted Price'
  },
  cashDaskPriceModal: {
    title: 'Cash Desk Price',
    currentPrice: 'Current Cash Desk Price',
    difference: 'Change',
    newPrice: 'New Cash Desk Price',
    min: 'Min Cash Desk Price',
    max: 'Max Cash Desk Price'
  },
  baseOverwriteModal: {
    abort: 'Cancel',
    overwrite: 'overwrite',
    notPossible: 'The past cannot be edited',
    overMaximum: 'Value is above maximum',
    belowMinimum: 'Value is below minimum',
    reset: 'reset'
  },
  multiDayDiscountOverwriteModal: {
    title: 'Target Product Price',
    max: 'Max Multi-Day Discount',
    min: 'Min Multi-Day Discount',
    dailyBaseRate: 'Daily Base Rate',
    multiDayDiscountFactor: 'Multi-Day Discount Factor',
    productTargetPrice: 'Product Target Price',
    valueAndDemandFactor: 'Value And Demand Factor',
    currentPostedPrice: 'Current Posted Price',
    targetPriceTooLow: 'The new Current Posted Price is lower than the previous one. Original value: {val}',
    from: 'days from',
    infoBox: 'The changes to the target price will only be visible after the next price calculation.',
    noSlider: 'The slider is not available',
    basicPriceOverview: 'Basic price overview',
    multiDayDiscount: 'Multi-day discount',
    multiDayDiscountFacotrHelp: 'Multi-day discount factor',
    roundDiff: 'Rounding difference'
  },
  dailyBaseRateOverwriteModal: {
    title: 'Daily Base Rate for the',
    max: 'Max Daily Base Rate',
    min: 'Min Daily Base Rate',
    dailyBaseRate: 'Current Daily Base Rate',
    change: 'Change',
    newDailyBaseRate: 'New Daily Base Rate',
    infoBox: 'The changes to the Daily Base Rate will only be visible after the next price calculation.',
    basicPriceOverview: 'Basic price overview',
    workload: 'Expected utilization:',
    notOkWithDailyBR: 'Not satisfied with the Daily Base Rate?'
  },
  earlyBookingOverwriteModal: {
    title: 'Current Posted Price',
    max: 'Max Early Booking Discount',
    min: 'Min Early Booking Discount',
    dailyBaseRate: 'Daily Base Rate',
    earlyBookingFactor: 'Early Booking Discount Factor',
    productTargetPrice: 'Product Target Price',
    valueAndDemandFactor: 'Value And Demand Factor',
    currentPostedPrice: 'Current Posted Price (before structural element)',
    cashDeskPrice: 'Cash Desk Price',
    targetPriceTooLow: 'The new Current Posted Price is lower than the previous one. Original value: {val}',
    from: 'days from',
    infoBox: 'The changes to the Current Posted Price will only be visible after the next price calculation.',
    noSlider: 'The slider is not available',
    valDem: 'Value',
    currentEarlyBookingDiscount: 'Current Early Booking Discount',
    realizedDemandFactor: 'Realized demand factor',
    timeFactor: 'The Time Factor',
    multiDayDiscount: 'Multi-Day Discount Factor'
  },
  bookmarks: {
    title: 'Favorites lists',
    newList: 'New favorites list',
    noLists: 'You have not created a favorites list.',
    listName: 'List name',
    create: 'Create',
    required: 'Requires',
    maxChars: 'Maximum number of letters reached.',
    notUnique: 'List already exists.',
    editLists: 'Edit favorites',
    abort: 'Cancel',
    back: 'Back',
    removeList: 'Delete',
    noProdDefs: 'No entries',
    editListsTitle: 'Edit favorites',
    addListTitle: 'add to favorites',
    bookmarkFilter: 'Favorites'
  },
  realizedDemandChart: {
    overlayText: 'Number of sales:',
    yAxisLabel: 'Realized demand'
  },
  crowdFunding: { title: 'Support the construction of the 6-seater chairlift' },
  priceOverrideEvents: {
    selectProductDefinitions: 'Select product characteristic',
    description: 'Expression',
    newPrice: 'New price',
    newPriceRequired: 'Please enter new price.',
    override: 'Overwrite',
    noSelectedProductDefinitions: 'Select at least one product characteristic.',
    noDateGiven: 'Unexpected error: No date'
  },
  // stepper header texts
  stepperHeader: {
    chaeserrugg: {
      componentLevel: {
        Basket: { modalContent: '<p><strong>By age</strong></p>\n' + '<p><strong>Adult: </strong>20 years and older <br /> <strong>Senior:</strong> 65 years and older <br /> <strong>Youth:</strong> 16 &ndash; 19 years<br /> <strong>Child:</strong> 6 &ndash; 15 years<br /> </p>\n' + '<p>F&uuml;r die Altersabgrenzung ist der erste G&uuml;ltigkeitstag des Tickets entscheidend.</p>\n' + '<p>&nbsp;</p>\n' + '<p><strong>Day ski pass with SBB GA</strong></p>\n' + '<p>Holders of an SBB General Abonnement receive a reduction of around 20% on 1 and 2-day ski&auml;tickets. This discount can be selected when personalising the ski tickets (sp&auml;ter in the booking process)&auml;hlt. However, the ski ticket must be loaded onto the SwissPass. <br /> </p>\n' + '<p><strong>Speziell f&uuml;r Familien</strong><br /> Familien profitieren von speziellen Konditionen f&uuml;r Kinder ab einem 3-Tagespass. Ein Familientarif kommt nur zur Anwendung, wenn der Kinderskipass mit mindestens einem Elternteil gel&ouml;st wird.</p>' },
        SeasonAbos: { modalContent: '<p><strong>Winter map</strong></p>\n' + '<p><strong>Adult: </strong>20 years and older <br /> <strong>Senior:</strong> &nbsp;this category does not exist for subscribers <br /> <strong>Youth:</strong> 16 &ndash; 19 years<br /> <strong>Child:</strong> 6 &ndash; 15 years</p>\n' + '<p>With the winter card you can&ouml;enjoy the Ch&auml;serrugg area all winter &nbsp;: skiing, sledging, cross-country skiing, winter hiking as well as the train shares at full moon dinners and night skiing are included.</p>\n' + '<p>&nbsp;</p>\n' + '<p><strong>Winter card (Monday-Friday)</strong></p>\n' + '<p><strong>Adult: </strong>20 years and older <br /> <strong>Senior:</strong> &nbsp;this category does not exist for subscribers <br /> <strong>Youth:</strong> 16 &ndash; 19 years<br /> <strong>Child:</strong> 6 &ndash; 15 years</p>\n' + '<p>Mit der Winterkarte Mo-Fr k&ouml;nnen Sie w&auml;hrend den Wochentagen von Montag bis Freitag das Ch&auml;serrugg Gebiet geniessen. An Wochenenden (Samstag und Sonntag) ist dieses Abonnement nicht g&uuml;ltig. Falls Sie trotzdem mal an einem Wochenende kommen m&ouml;chten, k&ouml;nnen Sie gerne eine Tageskarte dazu buchen.</p>\n' + '<p>&nbsp;</p>\n' + '<p><strong>Winter map families</strong></p>\n' + '<p><strong>Adult : </strong>from 18 years <br /> <strong>Children :</strong> up to 17.99 years</p>\n' + '<p>As families you benefit from the attractive family card. The price of the family card includes a maximum of 2 adults plus any number of children living in the same household up to 17.99 years. The cut-off date for&uuml;age for winter passes is the start of t&auml;gual operation of the mountain lifts (e.g. start t&auml;gual operation on 15.12: children who are still under 16 years old by 15.12. still receive the children\'s rate).</p>' }
      },
      specificModuleComponentLevel: {
        hikingChaeserrugg: {
          SeasonAbos: {
            headerText: 'Information about the tickets',
            modalTitle: 'Information about the tickets',
            modalContent: '<p><strong>Age categories</strong></p>' + '<p>Adult: from 16 years</p>' + 'Children: 6 - 15 years' + '<p>&nbsp;</p>' + '<p><strong>SBB GA and HTX reductions</strong></p>' + 'SBB GA and HTX reductions can be claimed during the payment process.' + '<p>&nbsp;</p>' + '<p><strong>Hiking ticket</strong></p>' + 'Valid for three routes on the Unterwasser-Iltios-Chäserrugg axis. For example, if you take the train from Unterwasser to Iltios, hike from there to Chäserrugg and then take the train from the summit back to Unterwasser.' + '<p>&nbsp;</p>' + '<p><strong>Churfirsten ticket</strong></p>' + '1 ascent and 1 descent Unterwasser-Iltios or Alt St. Johann-Sellamatt, 1 post bus ride between Unterwasser and Alt St. Johann. For example, if you take the train from Alt St. Johann to Alp Sellamatt, hike to Iltios and from there take the funicular to Unterwasser.' + '<p>&nbsp;</p>' + '<p><strong>Hiking day map</strong></p>' + 'Use of all mountain railways in the Chäserrugg area incl. post bus between Unterwasser and Alt St. Johann. For example, if you travel from Alt St. Johann to Alp Sellamatt, hike from there via Hinterrugg to Chäserrugg and then take the train from the summit to Unterwasser.' + '<p>&nbsp;</p>' + '<p><strong>Textile exhibition ticket</strong></p>' + 'The hiking ticket for the STF exhibition on Chäserrugg entitles you to travel by train on 3 routes (one route is covered on foot). You can also use this ticket for free admission to the St. Gallen Textile Museum and for a taster course at the STF.'
          }
        },
        singleRideChaeserrugg: { Basket: { modalContent: '<p><strong>By age</strong></p>\n' + '<p><strong>Adult: </strong>16+ years <br /> <strong>Child:</strong> 6-15 years <br /></p>\n' + '<p>The first day of validity of the ticket is decisive for the age cut-off.</p>\n' + '<p>&nbsp;</p>\n' + '<p><strong>SBB Half-Fare and GA reductions</strong></p>\n' + '<p>Discounts on single journeys can be claimed later during the payment process with a valid GA or Half-Fare travelcard.</p>\n' } }
      }
    },
    bellwald: {
      componentLevel: {
        Basket: { modalContent: '<p>Adults: from 20 years<br />' + 'Teenagers: from 16 - 19 years<br />' + 'Children: from 6 - 15 years<br />' + 'Infants: from 0 - 5 years ride FREE in Bellwald. Only available at the ticket office.</p>' + 'The respective age at the time of use (1st day of validity) <br><br>applies.' + '<b>Transferable ski pass for partners/spouses with children.</b> <br> With the Partner Pass, only one of the two people can be on the slopes at any one time.<br><br>' + '<b>Special for families</b> <br> The 2nd child gets up to 20r discount, the 3rd and each further up to 30r discount (valid only from 3-day ski pass). <br><br>' + '<b>Disabled fare</b> <br> Discounted fare for persons accompanying disabled persons. Only available at the ticket counter. <br><br>' + '<b>4h-card</b> <br> Hourly card with a continuous validity of 4 hours at a time. Redeemable only over one ski day. Remaining hours cannot be used the next day.' },
        CrowdFunding: { modalContent: '<p>Make a voluntary G&ouml;nner contribution to the new construction of the 6-seater chairlift. All info about the project can be found here: <a class="sc-dPPMrM bBscpx" title="http://www.bellwald.ch/support" href="http://www.bellwald.ch/support" target="_blank" data-renderer-mark="true"><strong data-renderer-mark="true">ww.bellwald.ch/support</strong></a></p>' },
        StandardCalendar: {
          headerText: 'Choose your start date',
          modalTitle: 'Select suitable data',
          modalContent: 'Choose the right dates for your skiing pleasure. You can choose from 1 to a maximum of 14 days. You can change the duration in the list.'
        },
        SeasonAbos: { modalContent: 'Those guests who buy their subscription first will receive a voucher in addition to the subscription. ' + 'of your choice. Be it a day ski pass for friends, value vouchers from the mountain railway or a voucher from ' + 'the sports shop. Attention, the vouchers are only available in limited numbers. <br><br>' + 'The <b>partner ski pass</b> for partners/spouses is transferable between them. However, he can each ' + 'only be used by one person. Transfer to persons other than partner/spouse is excluded.<br><br>' + '<b>Adult</b>: 20 years or older<br>.' + '<b>Youth</b>: 16 - 19 years<br>' + '<b>child</b>: 6 - 15 years<br>' + '<b>partner</b>: 20 years or older<br>' + '<b>Infants</b> receive a free ski ticket at the ticket office' }
      }
    },
    moosalpregion: {
      componentLevel: {
        Basket: { modalContent: '<b>Adults</b>: Year 1999 and older <br>' + '<b>Youths</b>: Years 2000 to 2004 <br>.' + '<b>Children</b>: Years 2005 to 2011 <br>.' + '<b>Infants</b>: born 2012 and younger <br>.' + '<br><br>' + '<b>Especially for families</b> <br>' + 'Families benefit from a family discount of 5% if min. 1 adult person ' + '(max. 2 adult persons) in combination with min. two paying children (category child or ' + 'Youth) can be purchased.' },
        SeasonAbos: { modalContent: '<b>Adults</b>: Year 1999 and older <br>' + '<b>Youths</b>: Years 2000 to 2004 <br>.' + '<b>Children</b>: Years 2005 to 2011 <br>.' + '<b>Infants</b>: Year 2012 and younger <br><br>' + '<b>Points cards validity period:</b> 2 years from date of purchase <br><br>.' + '<b>Scorecard evaluation</b><br>' + '<table style="border-collapse: collapse;" border="solid"><tbody><tr>' + '<td width="201">Lift</td>' + '<td width="152">Adult / Teen</td>' + '<td width="138">child</td>' + '</tr><tr>' + '<td width="201">Bodmen children\'s lift</td>' + '<td width="152">1</td>' + '<td width="138">1</td>' + '</tr><tr>' + '<td width="201">leaf lift</td>' + '<td width="152">2</td>' + '<td width="138">1</td>' + '</tr><tr>' + '<td width="201">Chairlift</td>' + '<td width="152">3</td>' + '<td width="138">2</td>' + '</tr><tr>' + '<td width="201">Ronalplift</td>' + '<td width="152">3</td>' + '<td width="138">2</td>' + '</tr><tr>' + '<td width="201">sub-rate lift</td>' + '<td width="152">3</td>' + '<td width="138">2</td>' + '</tr><tr>' + '<td width="201">Moosalplift</td>' + '<td width="152">3</td>' + '<td width="138">2</td>' + '</tr><tr>' + '<td width="201">T&ouml;rbeltallift</td>' + '<td width="152">3</td>' + '<td width="138">2</td>' + '</tr></tbody></table>' },
        StandardCalendar: { modalContent: 'Choose the most suitable dates for your skiing pleasure. You can adjust the duration in the list.' },
        PerformanceDifferentiation: { modalContent: 'With the <b>Basic Tariff</b> you purchase a ski ticket, which is not rebooked or ' + 'can be cancelled. The ski ticket is only valid for the selected date.' + '<br><br>' + 'With the <b>Flex fare</b> you purchase a ski ticket that can be rebooked flexibly. You can ' + 'cancel the ticket until <b>23:59</b> before the 1st day of validity. In the event of cancellation, the entire ' + 'Booking cancelled. Cancellation of individual ski days of a multi-day ticket is not possible. ' + 'The original booking amount will be credited to you in the form of an online credit, ' + 'which you can redeem with your next online booking.' + '<br><br>' + 'With the <b>elective fare</b> (e.g., 5 out of 7 days), you purchase a ticket that gives you the flexibility to ' + 'gives to skip any two days in your chosen period, e.g. in case of bad weather.' },
        SeatReservation: {
          headerText: 'Obligatory seat reservation',
          modalTitle: 'What is a seat reservation?',
          modalContent: 'The places in the Alpuschnaager are limited. With an Alpuschnaager reservation you guarantee ' + 'we will book you a place at the Alpuschnaager at the selected time. When you make an Alpuschnaager reservation ' + 'have booked, we ask you to be at Egga or ' + 'for the return journey at Moosalp with your ticket (Print@Home or on your mobile phone). Otherwise ' + 'your Alpuschnaager reservation cannot be guaranteed.'
        }
      },
      specificModuleComponentLevel: { singleRideMoosalpregion: { Basket: { modalContent: '<b>Adults</b>: Year 1999 and older <br>' + '<b>Youths</b>: Years 2000 to 2004 <br>.' + '<b>Children</b>: Years 2005 to 2011 <br>.' + '<b>Infants</b>: born 2012 and younger <br>.' } } }
    },
    niesen: {
      componentLevel: {
        StandardCalendar: {
          headerText: 'Choose a travel date',
          modalTitle: 'Choose a travel date',
          modalContent: 'Click on the desired travel date in the calendar. A mountain railway trip is valid for one day.'
        },
        HotelCalendar: {
          headerText: 'Choose your arrival date',
          modalTitle: 'Choose an arrival date',
          modalContent: 'Select the desired arrival date in the calendar.'
        }
      }
    },
    // destination independent fallback
    destinationFallback: {
      Basket: { modalTitle: 'Tariff differentiations' },
      StandardCalendar: { headerText: 'Choose your date' },
      HotelRoomSelector: { headerText: 'Choose your favorite room type' },
      ContactForm: {
        headerText: 'Group request',
        modalContent: 'Group request',
        modalTitle: 'Group request'
      },
      SendRequest: { headerText: 'Send request' },
      SelectMedium: { headerText: 'Personalize your products' },
      SeatReservation: { modalTitle: 'What is a funicular reservation and what do I need to consider?' },
      SeasonAbos: {
        headerText: 'Subscription information',
        modalTitle: 'Subscription information'
      },
      ShopLogin: { headerText: 'Log in' }
    }
  },
  powerBi: {
    couldNotBeLoaded: 'Power BIs could not be retrieved.',
    couldNotBeSaved: 'Power BI could not be saved.',
    couldNotBeDeleted: 'Power BI could not be deleted.',
    urlMustNotBeEmpty: 'The URL must not be empty.',
    selectBi: 'Select your Power BI'
  },
  stornoHistory: {
    excelDownload: 'Export List',
    cancellations: 'Cancellations',
    voucher: 'Online Balance',
    exportCancellations: 'Export Cancellations',
    exportVoucher: 'Export Online Balance',
    customer: 'Customer',
    cancellationId: 'Cancellation id',
    customerId: 'Customer id',
    customerFirstName: 'Customer First Name',
    customerLastName: 'Customer Last Name',
    customerMail: 'Customer eMail',
    productName: 'Product',
    employeeFirstName: 'Employee First Name',
    employeeLastName: 'Employee Last Name',
    startDate: 'Start Date',
    endDate: 'End Date',
    priceNet: 'Price Net',
    priceGross: 'Price Gross',
    mail: 'Mail',
    reason: 'Reason',
    address: 'Address',
    zip: 'ZIP',
    city: 'City',
    currency: 'Currency',
    balance: 'Online Balance',
    noData: 'There is no data in the given timespan'
  },
  ticketProvider: {
    swisspass: 'Swisspass',
    novatouch: 'Novatouch',
    axess: 'Axess',
    skidata: 'Skidata',
    unknown: 'Unknown'
  },
  basketConditions: {
    unknownBasketCondition: 'Unknown basket condition',
    basketConditionsNotMet: 'Please refer to the terms and conditions with your selected product.',
    textComposition: {
      min: 'at least {count}x',
      max: 'maximum {count}x',
      but: 'but',
      conditionText: 'Add "{attributeTitle}" {conditionTexts} in the cart.'
    }
  }
};